<template>
  <div class="form-group" v-if="fbinvisible != 'true'">
    <div class="row" :style="fblabelposition == 'right'? 'flex-direction: row-reverse;': ''">
      <div class="col-form-label" :class="fblabelposition == 'top' ? 'col-sm-12' : fblabelposition == 'center' ? 'col-sm-12 text-center' : fblabelposition == null|| undefined || '' ? 'col-sm-12' :'col-sm-2'" v-if="fbhidelabel !== 'true'">
        
        <label><b style="color: red;" v-if="fbrequired == 'true'">*</b> {{fbsupportmultiplelanguages? $helper.getWord(fblabel) :fblabel || '&nbsp;' }}</label>
      </div>
      <div :class="fblabelposition == 'top'? 'col-sm-12' : fblabelposition == 'center' ? 'col-sm-12' : (fblabelposition == null || undefined || '')? 'col-sm-12' : 'col-sm-10'">
        <textarea ref="input" :placeholder="fbplaceholder" :value="value" class="form-control" :class="{ invalid: isValid === false }" :required="fbrequired == 'true' ? true : false" @change="dataChanged" autocomplete="nope" :readonly="checkReadonly(isedit, fbreadonly)"></textarea>
        <span v-if="fbhelptext" class="form-text text-muted">{{ fbhelptext }}</span>
        <!-- <label v-if="isValid === false" id="basic-error" class="validation-invalid-label" for="basic">{{ this.errormessage || $t('ui.SYS00016') }}</label>
        <label v-if="isFormatValid === false" id="basic-error" class="validation-invalid-label" for="basic">{{ $t('message.SYS00002', { digit: digit, decimal: decimal }) }}</label> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TextArea',
  props: ['id', 'fbsupportmultiplelanguages','fblabel', 'fbplaceholder', 'fbrows', 'value', 'fbvalue', "fbinvisible", 'fbmaxlength', 'fbminlength', 'format', 'fbreadonly', 'fblabelposition', 'labelwidth', 'fbrequired', 'fbhidelabel', 'fbhelptext', 'errormessage', 'allowedInput', 'type', 'blurValidation', 'isedit'],
  data () {
    return {
      isValid: true,
      isFormatValid: true,
      digit: 0,
      decimal: 0,
      beforeEditValue: null
    }
  },
  mounted () {
    this.$emit('input', this.fbvalue, this);
    if(this.value != null){
      this.$emit('input', this.value, this);
    }
    $(this.$refs.input).css('height', 15 * this.fbrows);
    

    if (this.allowedInput || this.blurValidation) {
      $(this.$refs.input).on('focus', $.proxy(function (e) {
        this.beforeEditValue = $(this.$refs.input).val()
      }, this))
      $(this.$refs.input).on(this.allowedInput ? 'keyup' : 'blur', $.proxy(function (e) {
        var re = new RegExp(this.allowedInput || this.blurValidation, 'i')
        if (!re.test($(this.$refs.input).val())) {
          this.$nextTick(() => {
            $(this.$refs.input).val(this.beforeEditValue)
            this.$emit('input', this.beforeEditValue, this)
          })
          e.preventDefault()
          e.stopPropagation()
          return false
        } else {
          this.beforeEditValue = $(this.$refs.input).val()
        }
      }, this))
    }

    if (this.format) {
      $(this.$refs.input).inputmask({
        regex: this.format,
        clearIncomplete: true,
        insertMode: false,
        showMaskOnHover: false
      })

      $(this.$refs.input).on('change', $.proxy(function (e) {
        this.$emit('input', $(e.target).val(), this)
      }, this))
    }

    if (this.maxlength) {
      $(this.$refs.input).maxlength({
        threshold: Math.floor(this.maxlength * 0.3)
      })
    }
  },
  methods: {
    setFocus () {
      this.$refs.input.focus()
    },
    setValid (val) {
      this.isValid = val
    },
    setFormatValid (val) {
      this.isFormatValid = val
    },
    isFieldValid () {
      var val = $(this.$refs.input).val()
      return !this.fbrequired || (this.fbrequired && val !== null && val !== undefined && val !== '')
    },
    isFieldFormatValid () {
      return !this.format || (this.format && this.matchFormat())
    },
    dataChanged (e) {
      this.$emit('input', $(e.target).val(), this)
    },
    matchFormat () {
      // Make sure the value matches format given
      if (!$(this.$refs.input).val() || !this.format) {
        return true
      }

      // var f = this.format.split(',')

      // var re = new RegExp('^(\\d){0,' + f[0] + '}(\\.(\\d){0,' + (f.length > 1 ? f[1] : '0') + '})?$', 'igm')
      var re = new RegExp(this.format, 'igm')
      return re.test($(this.$refs.input).val())
    },
    resetValue () {
      this.isValid = true
      $(this.$refs.input).val(null)
    },
    checkReadonly(isedit, fbreadonly){
      let readonly = true;
      if(isedit){
        if(fbreadonly == 'true'){
          readonly = true;
        }else{
          readonly = false;
        }

      }else{
        readonly = true;
      }
      return readonly;
    }
  },
  computed: {
    labelCol () {
      return this.labelwidth || 3
    }
  },
  watch: {
    value: function (val) {
      $(this.$refs.input).val(val)
      $(this.$refs.input).attr('data-org-value', val)

      this.setValid(this.isFieldValid())
    }
  }
}
</script>
<style>
textarea{
  min-height: 40px;
  resize: none;
}

</style>